const ROLE_OPTIONS = [
  { value: 'accountingTax', label: 'Accounting & Tax' },
  { value: 'agencyPartner', label: 'Agency Partner' },
  { value: 'analyst', label: 'Analyst' },
  { value: 'architectTechLead', label: 'Architect/Technical Lead' },
  { value: 'bankerInvestment', label: 'Banker - Investment' },
  { value: 'bankerCommercial', label: 'Banker - Commercial' },
  { value: 'boardMember', label: 'Board Member' },
  { value: 'brandManagement', label: 'Brand Management' },
  { value: 'businessDevelopment', label: 'Business Development' },
  { value: 'ceoFounder', label: 'CEO/Founder' },
  { value: 'cfoFinance', label: 'CFO/Finance' },
  { value: 'cooOperations', label: 'COO/Operations' },
  { value: 'chiefOfStaff', label: 'Chief of Staff' },
  { value: 'cioItLeadership', label: 'CIO/IT Leadership' },
  { value: 'clinicalProfessional', label: 'Clinical Professional/Healthcare Provider' },
  { value: 'cmoMarketing', label: 'CMO/Marketing' },
  { value: 'communityManagement', label: 'Community Management' },
  { value: 'consultantManagement', label: 'Consultant - Management' },
  { value: 'consultantTechnical', label: 'Consultant - Technical' },
  { value: 'corporateDevelopment', label: 'Corporate Development' },
  { value: 'creativeDirector', label: 'Creative Director/Content' },
  { value: 'ctoEngineering', label: 'CTO/Engineering' },
  { value: 'customerSuccess', label: 'Customer Success' },
  { value: 'dataScienceAnalytics', label: 'Data Science & Analytics' },
  { value: 'design', label: 'Design' },
  { value: 'developerRelations', label: 'Developer Relations/DevEx' },
  { value: 'engineeringHardware', label: 'Engineering - Hardware' },
  { value: 'engineeringSoftware', label: 'Engineering - Software' },
  { value: 'executiveCLevel', label: 'Executive - C-Suite' },
  { value: 'executiveSVPVP', label: 'Executive - SVP/VP' },
  { value: 'founderSerial', label: 'Founder - Serial' },
  { value: 'founderFirstTime', label: 'Founder - First Time' },
  { value: 'lawyerGeneralCounsel', label: 'Lawyer/General Counsel' },
  { value: 'growthUserAcquisition', label: 'Growth/User Acquisition' },
  { value: 'hrPeopleOps', label: 'HR/People Ops' },
  { value: 'industryAnalyst', label: 'Industry Analyst' },
  { value: 'infoSecurityPrivacy', label: 'Information Security/Privacy' },
  { value: 'vcInvestorEarly', label: 'VC Investor — Early' },
  { value: 'vcInvestorGrowth', label: 'VC Investor — Growth' },
  { value: 'privateEquityInvestor', label: 'Private Equity Investor' },
  { value: 'publicMarketsInvestor', label: 'Investor — Public Markets' },
  { value: 'journalistMedia', label: 'Journalist/Media' },
  { value: 'operations', label: 'Operations' },
  { value: 'policyGovtAffairs', label: 'Policy/Government Affairs' },
  { value: 'productManagement', label: 'Product Management' },
  { value: 'productMarketing', label: 'Product Marketing' },
  { value: 'realEstate', label: 'Real Estate' },
  { value: 'recruitingTalent', label: 'Recruiting/Talent' },
  { value: 'regulatoryCompliance', label: 'Regulatory Compliance' },
  { value: 'researchAcademic', label: 'Research - Academic' },
  { value: 'researchIndustry', label: 'Research - Industry' },
  { value: 'salesLeadership', label: 'Sales Leadership' },
  { value: 'salesEnterprise', label: 'Sales - Enterprise' },
  { value: 'salesSMBMidMarket', label: 'Sales - SMB/Mid-Market' },
  { value: 'scientificResearch', label: 'Scientific Research' },
  { value: 'strategy', label: 'Strategy' },
  { value: 'supplyChainLogistics', label: 'Supply Chain/Logistics' },
  { value: 'uxResearch', label: 'UX Research' },
  { value: 'wealthManagement', label: 'Wealth Management' },
  { value: 'solutionsEngineer', label: 'Solutions Engineer' },
  { value: 'technicalAccountManager', label: 'Technical Account Manager' },
  { value: 'ciso', label: 'CISO' },
  { value: 'other', label: 'Other' },
].sort((a, b) => a.label.localeCompare(b.label));

export { ROLE_OPTIONS };
